//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/accounting/accounts-receivable/reports";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      as_of_date: moment().format("MM/DD/YYYY"),
      headers: [],
      fields: ["unit", "resident", "past_resident", "thisMonth", "lastMonth", "previousMonths", "prepays", "total", 'ar_notes'],
      items: [],
      showPastResidents: true,
      loading: false,
      monthLabels: [moment().format("MMMM"), moment().subtract(1, "months").format("MMMM"), "Prior to " + moment().subtract(1, "months").format("MMMM")]
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("ar-aging-by-month-report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });

    Event.$on("exportArAgingByMonthToExcel", function () {
      return _this.exportToExcel();
    });
    Event.$on("exportArAgingByMonthToPdf", function () {
      return _this.exportToPdf();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("ar-aging-by-month-report");
    Event.$off("exportArAgingByMonthToExcel");
    Event.$off("exportArAgingByMonthToPdf");
  },

  methods: {
    exportToExcel: function exportToExcel() {
      this.loading = true;

      var data = {
        exportExcel: true,
        as_of_date: this.as_of_date,
        showPastResidents: this.showPastResidents,
        monthLabels: this.monthLabels
      };

      this.createExport(data, BASE_URL + "/aging-by-month", "ar-aging-by-month", ".xlsx");

      this.loading = false;
    },
    exportToPdf: function exportToPdf() {
      this.loading = true;

      var data = {
        exportPdf: true,
        as_of_date: this.as_of_date,
        showPastResidents: this.showPastResidents,
        monthLabels: this.monthLabels
      };

      this.createExport(data, BASE_URL + "/aging-by-month", "ar-aging-by-month", ".pdf");

      this.loading = false;
    },
    applyFilter: function applyFilter() {
      this.load();
    },
    load: function load() {
      var _this2 = this;

      this.items = [];
      this.loading = true;
      this.monthLabels = [moment(this.as_of_date).format("MMMM"), moment(this.as_of_date).subtract(1, "months").format("MMMM"), "Prior to " + moment(this.as_of_date).subtract(1, "months").format("MMMM")];
      this.headers = ["Unit", "Resident", "Past", { title: moment(this.as_of_date).format("MMMM"), filter: "toCurrency" }, {
        title: moment(this.as_of_date).subtract(1, "months").format("MMMM"),
        filter: "toCurrency"
      }, {
        title: "Prior to " + moment(this.as_of_date).subtract(1, "months").format("MMMM"),
        filter: "toCurrency"
      }, { title: "Prepays", filter: "toCurrency" }, { title: "Balance", filter: "toCurrency" }, "AR Notes"];
      axios.post(BASE_URL + "/aging-by-month", {
        as_of_date: this.as_of_date,
        showPastResidents: this.showPastResidents
      }).then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
      });
    }
  },
  computed: {
    filteredData: function filteredData() {
      if (this.showPastResidents) {
        return this.items;
      } else {
        return this.items.filter(function (resident) {
          return resident.past_resident != "Y";
        });
      }
    },
    totalThisMonth: function totalThisMonth() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.thisMonth;
      }, 0)).toFixed(2);
    },
    totalLastMonth: function totalLastMonth() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.lastMonth;
      }, 0)).toFixed(2);
    },
    totalPreviousMonths: function totalPreviousMonths() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.previousMonths;
      }, 0)).toFixed(2);
    },
    totalPrepays: function totalPrepays() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.prepays;
      }, 0)).toFixed(2);
    },
    totalTotal: function totalTotal() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.total;
      }, 0)).toFixed(2);
    },
    totalOwed: function totalOwed() {
      return Number.parseFloat(this.filteredData.reduce(function (prev, cur) {
        return prev + cur.total + cur.prepays;
      }, 0)).toFixed(2);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/ArAgingByMonthReport.vue
// module id = gKhn
// module chunks = 0 1